import React from "react";
import { useMessageSource } from "react-message-source";
import ShowMoreLessInfo from "../../../../ui/widgets/show-more-less-info";
import { MoreInfoProps } from "./types";

export default function MoreInfo(props: MoreInfoProps): React.JSX.Element {
  const { getMessage } = useMessageSource();
  return (
    <ShowMoreLessInfo
      label={{
        showMore: getMessage("ShowMoreLessInfo.moreInfo"),
        showLess: getMessage("ShowMoreLessInfo.lessInfo"),
      }}
      {...props}
    >
      {props.children}
    </ShowMoreLessInfo>
  );
}
